import {z} from 'zod';

export const SEARCH_TYPE_COMPANY = 'company_page';
export const SEARCH_TYPE_RECRUITMENT = 'recruiting_info';
export const SEARCH_TYPE_COLUMN = 'columns';
export const SEARCH_TYPE_SPECIAL = 'special';
export const SEARCH_TYPE_UNKNOWN = '';

export type SearchType =
  | typeof SEARCH_TYPE_COMPANY
  | typeof SEARCH_TYPE_RECRUITMENT
  | typeof SEARCH_TYPE_COLUMN
  | typeof SEARCH_TYPE_SPECIAL
  | typeof SEARCH_TYPE_UNKNOWN;

export const SearchTypes = {
  company: SEARCH_TYPE_COMPANY,
  recruitment: SEARCH_TYPE_RECRUITMENT,
  column: SEARCH_TYPE_COLUMN,
  special: SEARCH_TYPE_SPECIAL,
  unknown: SEARCH_TYPE_UNKNOWN,
};

export const SearchTypesEnum = z.nativeEnum(SearchTypes);
